export default __webpack_public_path__ + "./images/vu.4ae5e8e4.png";